import logo from '../Assets/Imgs/logos/Zeroz-Logo-Horizontal-Black.png';
import headerGame from '../Assets/Imgs/Header-Images-Game-1.png';

import NavBar from '../Components/NavBar';
import Footer from '../Components/Footer';
import SongCard from '../Components/SongCard';

function CheckoutSuccess() {
  return (
    <div className="App">
      <NavBar />
      <div className="App-header story-header headerGrowing">
        <img src={headerGame} className="header-img headerBGMoving" alt="header" />
        <div className="story-bg info-bg gameHeaderShade">
          <div className="blockWhite" style={{padding:'3%'}}>
            <img src={logo} className="logoInText" />
            <p>
            Hooray! Your purchase is complete :)<br/>
            We've sent an order confirmation to your email, and will email you when you order has shipped.<br/>
            <br/>
            Feel free to reach out for any questions about your order ah@sied.online
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CheckoutSuccess;
